/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Knowledge_Assistants_Ingest_Desc6Inputs */

const en_svc_rag_knowledge_assistants_ingest_desc6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Ingest_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Docs, tickets, PDFs and wikis flow in automatically and stay fresh.`)
};

const ar_svc_rag_knowledge_assistants_ingest_desc6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Ingest_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`المستندات والتذاكر وPDF والويكي تتدفق تلقائيا وتبقى حديثة.`)
};

const bn_svc_rag_knowledge_assistants_ingest_desc6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Ingest_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ডক, টিকিট, PDF আর উইকি স্বয়ংক্রিয়ভাবে ঢোকে আর তাজা থাকে।`)
};

const de_svc_rag_knowledge_assistants_ingest_desc6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Ingest_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumente, Tickets, PDFs und Wikis fließen automatisch ein und bleiben frisch.`)
};

const es_svc_rag_knowledge_assistants_ingest_desc6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Ingest_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentos, tickets, PDF y wikis entran automáticamente y se mantienen frescos.`)
};

const fr_svc_rag_knowledge_assistants_ingest_desc6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Ingest_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documents, tickets, PDF et wikis entrent automatiquement et restent frais.`)
};

const pt_svc_rag_knowledge_assistants_ingest_desc6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Ingest_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Documentos, tickets, PDF e wikis entram automaticamente e mantêm-se frescos.`)
};

const zh_svc_rag_knowledge_assistants_ingest_desc6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Ingest_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文档、工单、PDF 和 wiki 自动流入并保持新鲜。`)
};

const tr_svc_rag_knowledge_assistants_ingest_desc6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Ingest_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belgeler, biletler, PDF ve wikiler otomatik akar, hep taze kalır.`)
};

const ru_svc_rag_knowledge_assistants_ingest_desc6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Ingest_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Документы, тикеты, PDF и вики подтягиваются автоматически и остаются свежими.`)
};

const pl_svc_rag_knowledge_assistants_ingest_desc6 = /** @type {(inputs: Svc_Rag_Knowledge_Assistants_Ingest_Desc6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dokumenty, tickety, PDF i wiki wpływają automatycznie i zostają świeże.`)
};

/**
* | output |
* | --- |
* | "Docs, tickets, PDFs and wikis flow in automatically and stay fresh." |
*
* @param {Svc_Rag_Knowledge_Assistants_Ingest_Desc6Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_rag_knowledge_assistants_ingest_desc6 = /** @type {((inputs?: Svc_Rag_Knowledge_Assistants_Ingest_Desc6Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Knowledge_Assistants_Ingest_Desc6Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_rag_knowledge_assistants_ingest_desc6(inputs)
	if (locale === "bn") return bn_svc_rag_knowledge_assistants_ingest_desc6(inputs)
	if (locale === "de") return de_svc_rag_knowledge_assistants_ingest_desc6(inputs)
	if (locale === "es") return es_svc_rag_knowledge_assistants_ingest_desc6(inputs)
	if (locale === "fr") return fr_svc_rag_knowledge_assistants_ingest_desc6(inputs)
	if (locale === "pt") return pt_svc_rag_knowledge_assistants_ingest_desc6(inputs)
	if (locale === "zh") return zh_svc_rag_knowledge_assistants_ingest_desc6(inputs)
	if (locale === "tr") return tr_svc_rag_knowledge_assistants_ingest_desc6(inputs)
	if (locale === "ru") return ru_svc_rag_knowledge_assistants_ingest_desc6(inputs)
	if (locale === "pl") return pl_svc_rag_knowledge_assistants_ingest_desc6(inputs)
	return en_svc_rag_knowledge_assistants_ingest_desc6(inputs)
});
export { svc_rag_knowledge_assistants_ingest_desc6 as "svc_rag-knowledge-assistants_INGEST_desc" }